/* tslint:disable */
/* eslint-disable */
/**
 * Wire API (development)
 * The API for the Clientwire messaging service.
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: support@clientwire.net
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { OidcConfig } from './oidc-config';
import {
    OidcConfigFromJSON,
    OidcConfigFromJSONTyped,
    OidcConfigToJSON,
    OidcConfigToJSONTyped,
} from './oidc-config';

/**
 * Wrapper object for returning a list of OIDC configs.
 * @export
 * @interface OidcConfigList
 */
export interface OidcConfigList {
    /**
     * List of OIDC provider configurations for this tenant.
     * @type {Array<OidcConfig>}
     * @memberof OidcConfigList
     */
    oidcConfigs: Array<OidcConfig>;
}

/**
 * Check if a given object implements the OidcConfigList interface.
 */
export function instanceOfOidcConfigList(value: object): value is OidcConfigList {
    if (!('oidcConfigs' in value) || value['oidcConfigs'] === undefined) return false;
    return true;
}

export function OidcConfigListFromJSON(json: any): OidcConfigList {
    return OidcConfigListFromJSONTyped(json, false);
}

export function OidcConfigListFromJSONTyped(json: any, ignoreDiscriminator: boolean): OidcConfigList {
    if (json == null) {
        return json;
    }
    return {
        
        'oidcConfigs': ((json['oidc_configs'] as Array<any>).map(OidcConfigFromJSON)),
    };
}

export function OidcConfigListToJSON(json: any): OidcConfigList {
    return OidcConfigListToJSONTyped(json, false);
}

export function OidcConfigListToJSONTyped(value?: OidcConfigList | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'oidc_configs': ((value['oidcConfigs'] as Array<any>).map(OidcConfigToJSON)),
    };
}

